class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".pdp-content .product-form");

    if (!mainProductForm) return;

    const shouldRequireScroll = () => {
      return !window.matchMedia("(max-width: 767px)").matches;
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target.matches("footer.footer")) {
            if (entry.isIntersecting) {
              this.classList.remove(classes.show);
            }
            return;
          }

          if (entry.isIntersecting) {
            // Main product form is in view -> hide bar
            this.classList.remove(classes.show);
          } else if (!shouldRequireScroll() || window.scrollY > 200) {
            // Mobile: show immediately when main ATC/form is not visible
            // Desktop: keep original behavior, only show after scrolling a bit
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    document.addEventListener("DOMContentLoaded", () => {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);